import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { LazoLead } from "@/models/LazoLead";
import { BaseSignupFormData } from "@/types/SignupForm";

export interface utmParams {
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmTerm: string;
  utmContent: string;
}

class LeadService {
  path: string;
  constructor(path: string) {
    this.path = path;
  }

  async createLead(LazoLead: BaseSignupFormData, utmParams: utmParams): Promise<ApiResponseV2<LazoLead>> {
    const lead: LazoLead = {
      firstName: LazoLead.firstName,
      lastName: LazoLead.lastName,
      email: LazoLead.email,
      jobTitle: "",
      utmSource: utmParams.utmSource,
      utmMedium: utmParams.utmMedium,
      utmCampaign: utmParams.utmCampaign,
      utmTerm: utmParams.utmTerm,
      utmContent: utmParams.utmContent,
      user: null,
    };

    return HttpClientV2.post(`${this.path}/create`, lead);
  }

  async matchLeadToUser(LazoUser: BaseSignupFormData): Promise<ApiResponseV2<LazoLead>> {
    return HttpClientV2.put(`${this.path}/match-lead-to-user`, LazoUser);
  }
}

export default new LeadService("/api/lazo-lead");
